import React from 'react';

export default function PlusCircleIcon({className}) {
	return (
        <svg className={className ? className : ''} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" preserveAspectRatio="xMidYMid meet"><path d="M6 12c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6zM6 1C3.2 1 1 3.2 1 6s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5z"/><path d="M9.2 5.7H6.7V3.2c0-.3-.2-.5-.5-.5s-.5.2-.5.5v2.5H3.2c-.3 0-.5.2-.5.5s.2.5.5.5h2.5v2.5c0 .3.2.5.5.5s.5-.2.5-.5V6.7h2.5c.3 0 .5-.2.5-.5s-.3-.5-.5-.5z"/></svg>
	);
}
